import Vue from 'vue'
import VueRouter from 'vue-router'
import VueValidator from 'vue-validator'
import VueSortable from 'vue-sortable'
import VueAsyncComputed from 'vue-async-computed'

import LoginView from './views/Login.vue'
import DashboardView from './views/Dashboard.vue'
import ExercisesView from './views/ExercisesView.vue'
import ExerciseView from './views/ExerciseView.vue'
import SubexerciseView from './views/SubexerciseView.vue'
import TeamsView from './views/Teams.vue'
import Team from './views/Team.vue'
import NewTeam from './views/NewTeam'
import Sessions from './views/Sessions.vue'
import Notes from './views/Notes.vue'
import Participants from './views/Participants.vue'
import Survey from './views/Survey'
import ResetPassword from './views/ResetPassword'

import jwtDecode from 'jwt-decode'
import moment from 'moment'
import { RefreshToken } from 'api/resources'

Vue.use(VueRouter)
Vue.use(VueValidator)
Vue.use(VueSortable)
Vue.use(VueAsyncComputed)

Vue.validator('email', function(val) {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    val
  )
})

var router = new VueRouter({
  history: true
})

const map = {
  '/': {
    name: 'root',
    component: DashboardView
  },
  '/login': {
    name: 'login',
    component: LoginView
  },
  '/exercises': {
    name: 'exercises',
    component: ExercisesView
  },
  '/exercises/:id': {
    name: 'exercise',
    component: ExerciseView
  },
  '/exercises/:id/:subid': {
    name: 'subexercise',
    component: SubexerciseView
  },
  '/teams': {
    name: 'teams',
    component: TeamsView,
    meta: { forbiddenRoles: ['facilitator'] }
  },
  '/teams/:team': {
    name: 'team',
    component: Team,
    meta: { forbiddenRoles: ['facilitator'] }
  },
  'teams/:team/sessions': {
    name: 'sessions',
    component: Sessions,
    meta: { forbiddenRoles: ['facilitator'] }
  },
  'teams/:team/notes': {
    name: 'notes',
    component: Notes,
    meta: { forbiddenRoles: ['facilitator'] }
  },
  'teams/:team/participants': {
    name: 'participants',
    component: Participants,
    meta: { forbiddenRoles: ['facilitator'] }
  },
  'teams/new': {
    name: 'new-team',
    component: NewTeam,
    meta: { forbiddenRoles: ['facilitator'] }
  },
  'teams/:team/survey': {
    name: 'survey',
    component: Survey,
    meta: { forbiddenRoles: ['facilitator'] }
  },
  'password/reset/:token': {
    name: 'reset-password',
    component: ResetPassword
  }
}

router.map(map)

router.beforeEach(({ to, next }) => {
  window.scrollTo(0, 0)
  if (to.name === 'reset-password') {
    next()
    return
  }
  const encodedToken = router.app.$store._modules.auth.state.token
  if (!encodedToken) {
    console.log('%cNo token found', 'font-weight: bold; color: darkblue')
    // no token available, go to login
    router.go({ name: 'login' })
    next()
    return
  }

  // validate forbiddenRoles if set, forbid if user has one of forbiddenRoles or their role not recognised
  if (typeof to.meta !== 'undefined' && typeof to.meta.forbiddenRoles !== 'undefined') {
    const role = router.app.$store._modules.auth.state.role
    if (to.meta.forbiddenRoles.includes(role) || role === null) {
      console.log('%cRoute forbidden for user role', 'font-weight: bold; color: red', role)
      return false
    }
  }

  const token = jwtDecode(encodedToken)
  const date = moment(token.exp * 1000)
  const now = moment()

  if (!date.isBefore(now)) {
    console.log('%cToken is still valid', 'font-weight: bold; color: green')

    if (to.name === 'login') {
      // redirect to root if already logged in
      router.go({ name: 'root' })
    }
    next()
    return
  }

  // token has expired
  console.log('%cToken has expired', 'font-weight: bold; color: blue', token)

  // check if token is refreshable
  const isRefreshable = date.add(1, 'week').isAfter(now)
  console.log(
    '%cIs refreshable',
    'font-weight: bold; color: blue',
    isRefreshable
  )

  // Promise refresh token
  RefreshToken.get()
    .then(response => {
      const newToken = response.data.data.token
      console.log('%cOld token', 'font-weight: bold; color: grey', token)
      console.log(
        '%cNew token',
        'font-weight: bold; color: black',
        jwtDecode(newToken)
      )
      router.app.$store.dispatch('SET_TOKEN', newToken)
      next()
    })
    .catch(response => {
      console.log(
        '%cToken could not be refreshed',
        'font-weight: bold; color: red',
        response.body.message
      )
      router.go({ name: 'login' })
      next()
    })
})

export default router
export { map }



// WEBPACK FOOTER //
// ./src/router.js